// Administration Authentication & Credentials Manager
const ADMIN_EMAIL_KEY = 'bo_admin_email';
const ADMIN_PASSWORD_KEY = 'bo_admin_password';
const MUST_CHANGE_PASSWORD_KEY = 'bo_must_change_password';
const DEFAULT_ADMIN_EMAIL = 'admin@amoura.app';
const DEFAULT_ADMIN_PASSWORD = 'admin123';
const RECOVERY_CODE_KEY = 'bo_admin_recovery_code';

export function getAdminEmail(): string {
  return localStorage.getItem(ADMIN_EMAIL_KEY) || DEFAULT_ADMIN_EMAIL;
}

export function setAdminEmail(email: string): void {
  localStorage.setItem(ADMIN_EMAIL_KEY, email.trim());
}

export function getAdminPassword(): string {
  return localStorage.getItem(ADMIN_PASSWORD_KEY) || DEFAULT_ADMIN_PASSWORD;
}

export function setAdminPassword(password: string): void {
  localStorage.setItem(ADMIN_PASSWORD_KEY, password);
}

export function isMustChangePassword(): boolean {
  const flag = sessionStorage.getItem(MUST_CHANGE_PASSWORD_KEY);
  if (flag !== null) return flag === '1';
  // If the admin password is still the default 'admin123', prompt for first-time password change
  return getAdminPassword() === DEFAULT_ADMIN_PASSWORD;
}

export function setMustChangePassword(val: boolean): void {
  sessionStorage.setItem(MUST_CHANGE_PASSWORD_KEY, val ? '1' : '0');
}

export function verifyAdminCredentials(email: string, password: string): boolean {
  const currentEmail = getAdminEmail().toLowerCase();
  const fallbackEmail = 'admin@datingapp.com';
  const inputEmail = email.trim().toLowerCase();
  const currentPassword = getAdminPassword();
  const isEmailMatch = inputEmail === currentEmail || inputEmail === fallbackEmail;
  return isEmailMatch && password === currentPassword;
}

export function sendRecoveryCode(email: string): { success: boolean; code?: string; message: string } {
  const currentEmail = getAdminEmail().toLowerCase();
  if (email.trim().toLowerCase() !== currentEmail) {
    return {
      success: false,
      message: 'No administrator account found with this email address.',
    };
  }
  const code = Math.floor(100000 + Math.random() * 900000).toString();
  sessionStorage.setItem(
    RECOVERY_CODE_KEY,
    JSON.stringify({ code, email: email.trim(), expiresAt: Date.now() + 15 * 60 * 1000 })
  );
  return {
    success: true,
    code,
    message: `A 6-digit recovery code has been generated for ${email}.`,
  };
}

export function resetAdminPassword(code: string, newPassword: string): { success: boolean; message: string } {
  const raw = sessionStorage.getItem(RECOVERY_CODE_KEY);
  if (!raw) {
    return { success: false, message: 'Recovery session expired or not found. Please request a new code.' };
  }
  try {
    const data = JSON.parse(raw);
    if (Date.now() > data.expiresAt) {
      sessionStorage.removeItem(RECOVERY_CODE_KEY);
      return { success: false, message: 'Recovery code has expired. Please request a new one.' };
    }
    if (data.code !== code.trim()) {
      return { success: false, message: 'Invalid 6-digit verification code. Please check and try again.' };
    }
    if (newPassword.length < 6) {
      return { success: false, message: 'Password must be at least 6 characters long.' };
    }
    setAdminPassword(newPassword);
    sessionStorage.removeItem(RECOVERY_CODE_KEY);
    return { success: true, message: 'Password successfully reset! You can now log in.' };
  } catch {
    return { success: false, message: 'Invalid recovery session data.' };
  }
}

export function changeAdminPassword(currentPassword: string, newPassword: string): { success: boolean; message: string } {
  if (currentPassword !== getAdminPassword()) {
    return { success: false, message: 'Current password is incorrect.' };
  }
  if (newPassword.length < 6) {
    return { success: false, message: 'New password must be at least 6 characters long.' };
  }
  setAdminPassword(newPassword);
  setMustChangePassword(false);
  return { success: true, message: 'Password updated successfully.' };
}
